// extracted by mini-css-extract-plugin
module.exports = {"root":"ColumnAccessor_root__GGhUH","cell":"ColumnAccessor_cell__3adg6","firstCellAccent":"ColumnAccessor_firstCellAccent__2eMc3"};